module.exports = __webpack_public_path__ + "img/wire-guide.bce94017.svg";